/* eslint-disable @typescript-eslint/naming-convention */
import { BettingMode, MaxPayoutType, OfficeNumberRounding, PageType } from '../enums';
import { ISuperBetSettings } from './superBetSettings.interface';
import { IBusinessModel } from '../settings/businessModel.interface';
import { ICurrency } from '../settings/currency.interface';
import { ITaxDefinitionTO } from '../settings/transportObjects/taxDefinitionTO.interface';
import { ViewConfigurations } from './viewConfigurations';
import { UtilityService } from 'src/app/services/util/utility.service';

export class ConstantValues {

  public static MAX_INACTIVITY_MIN = 120;
  public static MAX_EVENTS_IN_TICKET = 40;
  public static MAX_MULTI_EVENTS_IN_TICKET = 15;
  public static MAX_OUTCOMES_IN_EVENT = 5;
  public static MIN_STAKE = 30;
  public static MIN_STAKE_PER_COMB = 3;
  public static MAX_COMBINATIONS = 1000000;
  public static MAX_PAY_OUT = 45000000;
  public static MAX_STAKE = 15000000;
  public static REMOVE_LIVE_EVENT_DELAY_MINS = 5;
  public static NUMBER_OF_INITIAL_EVENTS_PM = 25;
  public static SPORT_TREE_REFRESH_INTERVAL_SEC = 30;
  public static LIVE_EVENTS_REFRESH_INTERVAL_MIN = 5;
  public static INITIAL_TOTAL_STAKE = 100;
  public static CACHE_INTERVAL_PM_SEC = 10;
  public static CACHE_INTERVAL_LIVE_SEC = 2;
  public static PAGE_ID_PM = 3;
  public static PAGE_ID_LIVE = 5;
  public static PAGE_ID_SUPERBET = 27;
  public static PAGE_ID_EVENTOFDAY = 28;
  public static BET_PRODUCT_ID = 2;
  public static BET_PRODUCT_MOBILE_ID = 2;
  public static BANKERSGROUP_ID = 1;
  public static SYSTEMSGROUP_ID = 2;
  public static FIX_TICKET_TYPE_ID = 10;
  public static SYSTEM_TICKET_TYPE_ID = 1;
  public static SINGLE_TICKET_TYPE_ID = 11;
  public static TAX_FREE_AMOUNT: number;
  public static NUMBER_OF_INITIAL_SPORTS_PM = 8;
  public static HOURS_TO_SPORTS_STARTING_SOON: number = 365 * 24;
  public static SEARCH_VALUE_MIN_LENGTH = 3;
  public static SEARCH_VALUE_MAX_LENGTH = 50;
  public static MAX_TOTAL_ODD = 999999999;
  public static BETTING_MODE: BettingMode;
  // static DISPLAY_NUMBER_FORMAT: TOOfficeDisplayNumberFormat = 2;
  public static DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE = '1.2-2';
  // static ID: number;
  public static IS_ON_NET_WINNING: boolean;
  public static LIVE_BETTING_DELAY_TIME_SEC: number;
  public static MAX_PAYOUT_TIME: number;
  public static NUMBER_ROUNDING: OfficeNumberRounding = 2;
  public static OFFICE_NAME: string;
  public static IINTIAL_MOBILE_PAGE_TYPE: PageType = PageType.HomePage;
  public static CURRENCY = '';
  public static MAX_PAYOUT_TYPE: MaxPayoutType;
  public static TICKET_ID_SIZE = 14;
  public static TICKET_PIN_SIZE = 4;
  public static TICKET_ACCEPT_TIME_SEC_PM = 180;
  public static TICKET_ACCEPT_TIME_SEC_LIVE = 180;
  public static MAX_TICKET_ID_SIZE = 16;
  public static MIN_TICKET_ID_SIZE = 12;
  public static SUPER_BET_MAX_SB_TICKETITEMS = 0;
  public static SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS = 0;
  public static SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD = 1;
  public static PREDEFINED_DENOMINATIONS = [];
  public static STORNO_ALLOWED_MINUTES = 5;
  public static TAX_DEFINITIONS: ITaxDefinitionTO;

  public static setCurrency(curr: ICurrency): void {

    if (curr) {
      this.CURRENCY = curr.code;
      this.PREDEFINED_DENOMINATIONS = curr.predefinedDenominations.sort((a, b) => a - b);
    }

    // switch (this.CURRENCY) {
    //   case 'RSD':
    //     this.INITIAL_TOTAL_STAKE = 100;
    //     break;
    //   case 'EUR':
    //     this.INITIAL_TOTAL_STAKE = 1;
    //     break;

    //   default:
    //     this.INITIAL_TOTAL_STAKE = 100;
    //     break;
    // }

  }

  public static setAcceptanceTimeout(timeoutPmMs: number, timeoutLiveMs: number) {
    this.TICKET_ACCEPT_TIME_SEC_PM = timeoutPmMs / 1000;
    this.TICKET_ACCEPT_TIME_SEC_LIVE = timeoutLiveMs / 1000;
  }

  public static setSuperBetSettings(settings: ISuperBetSettings) {
    if (settings && settings.id > 0) {
      this.SUPER_BET_MAX_SB_TICKETITEMS = settings.maximimSuperBetTicketItems ? settings.maximimSuperBetTicketItems : 0;
      this.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS = settings.requiredNonSuperBetTicketItems ? settings.requiredNonSuperBetTicketItems : 0;
      this.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD = settings.minNonSuperBetOdd ? settings.minNonSuperBetOdd : 1;
    } else {
      this.SUPER_BET_MAX_SB_TICKETITEMS = 0;
      this.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS = 0;
      this.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD = 1;
    }
  }

  public static setBussinesModel(businessModel: IBusinessModel, isMobile: boolean) {
    this.MAX_EVENTS_IN_TICKET = businessModel.maxEventsOnBetslip;
    // this.MAX_MULTI_EVENTS_IN_TICKET = businessModel.
    this.MAX_OUTCOMES_IN_EVENT = businessModel.maxMultiwayPerEvent ? businessModel.maxMultiwayPerEvent : 7;
    this.MIN_STAKE = businessModel.minStakePerBetslip;
    this.MIN_STAKE_PER_COMB = businessModel.minStakePerCombination;
    // this.MAX_COMBINATIONS = businessModel
    this.MAX_PAY_OUT = businessModel.maxPayout;
    this.MAX_TOTAL_ODD = businessModel.maxTotalOdd;
    this.MAX_STAKE = businessModel.maxStake;
    // this.REMOVE_LIVE_EVENT_DELAY_MINS = businessModel
    // this.NUMBER_OF_INITIAL_EVENTS_PM = businessModel
    // this.SPORT_TREE_REFRESH_INTERVAL_SEC = businessModel
    // this.LIVE_EVENTS_REFRESH_INTERVAL_MIN = businessModel
    this.INITIAL_TOTAL_STAKE = businessModel.defaultStake ? businessModel.defaultStake : ViewConfigurations.showTicketDialogMobileV2 && isMobile ? 10 : businessModel.minStakePerBetslip;
    // this.CACHE_INTERVAL_PM_SEC = businessModel
    // this.CACHE_INTERVAL_LIVE_SEC = businessModel
    // this.PAGE_ID_PM = businessModel
    // this.PAGE_ID_LIVE = businessModel
    // this.BET_PRODUCT_ID = businessModel
    // this.BANKERSGROUP_ID = businessModel
    // this.SYSTEMSGROUP_ID = businessModel
    // this.FIX_TICKET_TYPE_ID = businessModel
    // this.SYSTEM_TICKET_TYPE_ID = businessModel
    // this.SINGLE_TICKET_TYPE_ID = businessModel
    // this.NUMBER_OF_INITIAL_SPORTS_PM = businessModel
    // this.HOURS_TO_SPORTS_STARTING_SOON = businessModel
    // this.SEARCH_VALUE_MIN_LENGTH = businessModel
    // this.SEARCH_VALUE_MAX_LENGTH = businessModel
    this.TAX_FREE_AMOUNT = businessModel.taxFreeAmount;
    this.BETTING_MODE = businessModel.bettingMode;
    // this.DISPLAY_NUMBER_FORMAT = businessModel.displayNumberFormat;
    // this.ID= businessModel.ID;
    this.IS_ON_NET_WINNING = businessModel.isOnNetWinning;
    this.LIVE_BETTING_DELAY_TIME_SEC = businessModel.liveBettingDelayTime;
    this.MAX_PAYOUT_TIME = businessModel.maxPayoutTime;
    this.NUMBER_ROUNDING = businessModel.numberRounding;
    this.OFFICE_NAME = businessModel.officeName;
    this.MAX_PAYOUT_TYPE = businessModel.maxPayoutType;
    this.TAX_DEFINITIONS = businessModel.taxDefinition;
    this.STORNO_ALLOWED_MINUTES = businessModel.voidAllowedTime;
    // switch (this.DISPLAY_NUMBER_FORMAT) {
    //     case TOOfficeDisplayNumberFormat.OneDecimal:
    //         this.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE = '1.1-1';
    //         break;
    //     case TOOfficeDisplayNumberFormat.TwoDecimal:
    //         this.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE = '1.2-2';
    //         break;
    //     case TOOfficeDisplayNumberFormat.NoDecimals:
    //         this.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE = '1.0-0'
    //         break;
    //     case TOOfficeDisplayNumberFormat.None:
    //         this.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE = '1.0-5'
    //         break;
    //     default:
    //         break;
    // }

  }
}
